<!--
 * Path: src/features/browser/forms/icon/IconRead.vue
 * Task: Read-only display of an icon field showing the material icon and its class name.
-->
<template>
  <div class="mb-4">
    <div class="d-flex align-center mt-2 px-2">
      <v-avatar :color="entityColor" size="32" class="me-3 elevation-1" style="border-radius: 10px; border: 1px solid rgba(128,128,128,0.2);">
        <v-icon color="white" size="18">{{ modelValue || defaultIcon }}</v-icon>
      </v-avatar>
      <span class="text-body-1 text-high-emphasis font-family-mono">{{ modelValue || defaultIcon }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue?: string;
  defaultIcon?: string;
  entityColor?: string;
}

withDefaults(defineProps<Props>(), {
  modelValue: '',
  defaultIcon: 'mdi-shape',
  entityColor: 'grey'
});
</script>

<style scoped>
.font-family-mono {
  font-family: monospace;
}
</style>
